import React from 'react';
import gif from '../../assets/images/FINGER_print.gif';
import fingurePrint from '../../assets/images/fingureImage.png';


function CaptureFingerprint({fingerprintLoader,Capture,aepsStatus}) {


    const submit = () =>{
        if(aepsStatus === 'CAPTUR_FOR_LOGIN'){
            Capture('login')
        }else if(aepsStatus === "CAPTUR_MERCHANT_FOR_TXN"){
            Capture('merchant');
        }else{
            Capture('customer');
        }
       
    }


    return(
		<div className="tab-content-left">
					<h2>
						{aepsStatus === 'CAPTUR_FOR_LOGIN'
							? 'VERIFY RETAILER FINGERPRINT FOR LOGIN'
							: aepsStatus === 'CAPTUR_MERCHANT_FOR_TXN'
							?'VERIFY RETAILER FINGERPRINT FOR WITHDRAWAL'
							:'VERIFY CUSTOMER FINGERPRINT' }
					</h2>

					<img style={{ height: '135px', display: 'block', margin: '60px auto' }} className="mt20" src={fingerprintLoader ? gif : fingurePrint}></img>
				
					
						          <button type="submit" className="button-outline" disabled={fingerprintLoader} onClick={fingerprintLoader?()=>{}:()=>submit()}>
									{fingerprintLoader ? "CAPTURING..." : "FINGER PRINT VERIFY"}
								</button>
						
					
				</div>
	)
}

export default CaptureFingerprint;